import { css, styled, ThemeInterface } from 'styles';
import { rem } from 'polished';
import { BodyText } from '@unmind/design-system-components-web';
import { Link } from 'react-router-dom';
import { small } from '../../../utils';

import { Arrow } from '../../../icons';

export const CardWrapper = styled.article<{ defocused: boolean }>`
  width: 100%;
  position: relative;
  margin-bottom: ${rem(16)};
  padding: ${rem(24)};
  border-radius: ${rem(20)};
  background-color: ${({ defocused, theme }) =>
    defocused
      ? theme.colors.background.secondary
      : theme.colors.background.card};

  > p {
    margin: 0 0 ${rem(16)} 0;

    &:last-child {
      margin-bottom: 0;
    }

    &,
    a {
      font-size: ${({ theme }) => rem(theme.typography.fontSizes.fontSize16)};
    }
  }
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-top: 8px;

  ${small(css`
    margin-top: 20px;
  `)}
`;

export const CardBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${rem(4)};
`;

export const MeetingText = styled(BodyText).attrs(
  ({ theme }: { theme: ThemeInterface }) => ({
    color: theme.colors.text.link,
    forwardedAs: 'a',
    sizes: [theme.typography.fontSizes.fontSize16],
    weight: theme.typography.fontWeights.regular,
  }),
)`
  display: flex;
  justify-content: center;
`;

export const CardHeading = styled.div`
  margin-bottom: ${rem(24)};
  display: flex;
  flex-flow: row;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ImageWrapper = styled.p`
  background: ${({ theme }) => theme.colors.border.secondary};
  height: ${rem(44)};
  width: ${rem(44)};
  min-width: ${rem(44)};
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 3px 6px -2px ${({ theme }) => theme.colors.boxShadow},
    0px 6px 12px -3px ${({ theme }) => theme.colors.boxShadow};
  margin: 0 ${rem(12)} 0 0;
`;

export const Image = styled.img.attrs({
  alt: '',
})`
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
`;

export const TitleWrapper = styled.div`
  &:has(+ .action-wrapper) {
    margin-right: ${rem(16)};
  }
`;

export const Title = styled.p`
  margin: 0 0 ${rem(8)} 0;
  font-size: ${({ theme }) => rem(theme.typography.fontSizes.fontSize18)};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeights.semiBold};
  display: block;
`;

export const Small = styled.small`
  font-size: ${({ theme }) => rem(theme.typography.fontSizes.fontSize18)};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  display: block;
`;

export const ActionWrapper = styled.p`
  margin: 0 0 auto auto;
`;

export const MetaActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Anchor = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
  color: theme.colors.text.link,
  weight: theme.typography.fontWeights.regular,
}))`
  display: inline;
`;

export const BrowseLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  font-size: ${({ theme }) => rem(theme.typography.fontSizes.fontSize14)};
`;

export const BrowseLinkArrow = styled(Arrow).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  width: 16,
  height: 9,
}))`
  margin-left: 8px;
`;

export const UpcomingEventWrapper = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div<{ fullWidth?: boolean }>`
  width: 100%;

  ${({ fullWidth }) =>
    !fullWidth &&
    css`
      ${small(css`
        width: calc(50% - 1rem);
      `)}
    `}}

`;

export const HelpCentreLinkWrapper = styled.div`
  width: 100%;

  > a {
    margin-left: ${rem(5)};
    font-size: ${({ theme }) => rem(theme.typography.fontSizes.fontSize16)};
  }

  @media (min-width: 561px) and (max-width: 575px),
    (min-width: 830px) and (max-width: 1047px),
    (min-width: 1240px) {
    width: 50%;
  }
`;
